"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCirrusAuthenticationDetails = void 0;
const react_1 = require("react");
function useCirrusAuthenticationDetails(socket) {
    const [authentication, setAuthentication] = react_1.useState({ sessionId: null, authenticationMethod: null });
    react_1.useEffect(() => {
        setAuthentication({
            sessionId: socket.sessionId,
            authenticationMethod: socket.isAuthenticatedWith,
        });
    }, [socket]);
    react_1.useEffect(() => {
        const abortController = new AbortController();
        socket.authenticated().then(() => {
            if (!abortController.signal.aborted) {
                setAuthentication({
                    sessionId: socket.sessionId,
                    authenticationMethod: socket.isAuthenticatedWith,
                });
            }
        });
        return () => {
            abortController.abort();
        };
    }, [socket]);
    return react_1.useMemo(() => (Object.assign(Object.assign({}, authentication), { isAuthenticated: !!authentication.authenticationMethod })), [authentication]);
}
exports.useCirrusAuthenticationDetails = useCirrusAuthenticationDetails;
//# sourceMappingURL=useCirrusAuthenticationDetails.js.map